export default __webpack_public_path__ + "static/media/rainy.9305701c.svg";